import { fetch } from './http.util';
import { familyApiFetch } from './AuthProvider';
import { config } from './Config';

export async function getWeather() {
  return await familyApiFetch(fetch, `${config.apiEndpoints.familyLifeBaseUri}weather`, {});
}
